import {tracking_events} from '@utilities/track-abstract/track-abstract';

// Google Analytics
// Global site tag (gtag.js) - Google Analytics
window.dataLayer = window.dataLayer || [];
if (typeof window.gtag !== 'function') {
    window.gtag = function() {
        window.dataLayer.push(arguments);
    };
}
if (typeof window.promised_gtag !== 'object') {
    window.promised_gtag = new Promise((resolve) => {
        window.___resolvePromisedGtag = resolve;
    });
}

let tracking_started = false;

const sal_gtag = {
    start_tracking: () => {
        if (tracking_started) {
            return;
        } else {
            tracking_started = true;
        }

        if (!window.ga_id) {
            return;
        }

        const src = 'https://www.googletagmanager.com/gtag/js?id=' + window.ga_id;

        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = src;
        window.gtag('js', new Date());
        window.gtag('config', window.ga_id, {
            'anonymize_ip': true,
            'custom_map': {
                'dimension1': 'dim_market',
                'dimension2': 'dim_context'
            },
            'dimension1': window.market + '-' + window.language,
            'dimension2': window.ga_context || 'default',
            'send_page_view': !window.ga_disable_automatic_page_view
        });
        if (typeof window.___resolvePromisedGtag === 'function') {
            window.___resolvePromisedGtag(window.gtag);
        }

        document.body.appendChild(scriptTag);

        // Scroll-Tiefe
        let maxScrolled = 0;
        const sendMaxScrolled = function() {
            window.gtag('event', 'Scrolltracking', {
                'event_category': 'Scrolltracking',
                'event_label': 'Max Scrolltiefe (%)',
                'value': maxScrolled,
                'non_interaction': true
            });
        }
        const updateMaxScrolled = function() {
            const scrollpoint = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) + window.innerHeight;
            const percent = Math.max(0, Math.min(100, Math.round(scrollpoint / document.body.scrollHeight * 10) * 10));
            if (maxScrolled < percent) {
                maxScrolled = percent;
            }
            if (percent === 100) {
                sendMaxScrolled();
                window.removeEventListener('scroll', updateMaxScrolled);
                window.removeEventListener('beforeunload', sendMaxScrolled);
            }
        };


        window.addEventListener('scroll', updateMaxScrolled);
        window.addEventListener('beforeunload', sendMaxScrolled);


        // Initial Page Events
        if (Array.isArray(window.gtagInitialEvents)) {
            window.gtagInitialEvents.forEach(event => {
                const [category, action, label, value] = event;
                if (!category || !action) {
                    return;
                }
                const eventData = {};
                if (category) eventData['event_category'] = category;
                if (label) eventData['event_label'] = label;
                if (value) eventData['event_value'] = value;
                window.gtag('event', action, eventData);
            });
        }
    },
    track_event: (event, payload) => {
        switch (event) {
        case tracking_events.ClickHttp:
            // Klick auf Externe Links
            if (payload.indexOf('www.pfleiderer.com') === -1) {
                window.gtag('event', 'Klick', {
                    'event_category': 'Extern',
                    'event_label': payload
                });
            }
            break;
            // Klick auf Mailto:Links
        case tracking_events.ClickEmail:
            window.gtag('event', 'Klick', {
                'event_category': 'MailTo',
                'event_label': payload
            });
            break;
            // Klick auf Tel:Links
        case tracking_events.ClickPhone:
            window.gtag('event', 'Klick', {
                'event_category': 'Telefon',
                'event_label': payload
            });
            break;
            // Klick auf Downloads
        case tracking_events.ClickDownload:
            window.gtag('event', 'Download', {
                'event_category': payload.dlcat,
                'event_label': payload.dlid
            });
            break;
            // Klick auf Add To Wishlist
        case tracking_events.AddToWishlist:
            window.gtag('event', 'Klick', {
                'event_category': 'Merkzettel',
                'event_label': payload.id + ': ' + payload.title + ' ' + payload.subtitle + ' ' + payload.subsubtitle
            });
            break;
            // Klick auf Add To Warenkorb
        case tracking_events.AddToCart:
            if (payload) {
                window.gtag('event', 'Klick', {
                    'event_category': 'Warenkorb',
                    'event_label': payload.id + ': ' + payload.title + ' ' + payload.subtitle + ' ' + payload.subsubtitle
                });
            }
            break;
            // Klick auf Social Media Links
        case tracking_events.ClickSocial:
            window.gtag('event', 'Klick', {
                'event_category': 'Social',
                'event_label': payload
            });
            break;
            // Klick auf Kontakt-Flyout
        case tracking_events.ClickFlyout:
            window.gtag('event', 'Klick', {
                'event_category': 'Social',
                'event_label': 'Kontakt'
            });
            break;
            // Moodboard Upload
        case tracking_events.MoodboardUpload:
            window.gtag('event', 'upload', {
                'event_category': 'Moodboard'
            });
            break;
            // Roomdesigner
        case tracking_events.RoomDesignerOpen:
            window.gtag('event', 'open', {
                'event_category': 'RoomDesigner',
                'event_label': payload
            });
            break;

            // Newsletter
        case tracking_events.SubscribeNewsletter:
            window.gtag('event', 'Subscribe', {
                'event_category': 'Newsletter',
                'event_label': payload.variant || 'unknown'
            });
            break;


        case tracking_events.ConstructionStageSlideInteraction:
            window.gtag('event', 'SlideInteraction', {
                'event_category': 'ConstructionStage'
            })
            break;
        case tracking_events.ConstructionStageCategoryInteraction:
            window.gtag('event', 'CategoryInteraction', {
                'event_category': 'ConstructionStage'
            })
            break;
        case tracking_events.ConstructionStageLayerInteraction:
            window.gtag('event', 'LayerInteraction', {
                'event_category': 'ConstructionStage',
                'event_label': payload
            })
            break;
        case tracking_events.ConstructionStageSelectCategory:
            window.gtag('event', 'SelectCategory', {
                'event_category': 'ConstructionStage',
                'event_label': payload
            })
            break;
        case tracking_events.ConstructionStageSelectBauteil:
            window.gtag('event', 'SelectBauteil', {
                'event_category': 'ConstructionStage',
                'event_label': payload
            })
            break;
        case tracking_events.ConstructionStageClickProduct:
            window.gtag('event', 'ClickProduct', {
                'event_category': 'ConstructionStage',
                'event_label': payload
            })
            break;

        case tracking_events.SearchPage:
            if (typeof payload === 'string') {
                window.gtag('event', 'search', {
                    'event_label': payload.toLowerCase(),
                    'event_category': 'Searchpage'
                });
            }
            break;

        case tracking_events.SearchQuicksearch:
            if (typeof payload === 'string') {
                window.gtag('event', 'search', {
                    'event_label': payload.toLowerCase(),
                    'event_category': 'Quicksearch'
                });
            }
            break;

        case tracking_events.SearchAvailabilityEntrypage:
            if (typeof payload === 'string') {
                window.gtag('event', 'search', {
                    'event_label': payload.toLowerCase(),
                    'event_category': 'AvailabilityEntrypage'
                });
            }
            break;


        case tracking_events.global_gallery_slider_navigate_auto:
            window.gtag('event', 'navigate_auto', {
                'event_category': payload.category,
                'event_label': payload.title
            });
            break;

        case tracking_events.global_gallery_slider_navigate:
            window.gtag('event', 'navigate', {
                'event_category': payload.category,
                'event_label': payload.title
            });
            break;

        case tracking_events.global_gallery_slider_click:
            window.gtag('event', 'click_cta', {
                'event_category': payload.category,
                'event_label': payload.title
            });
            break;
        case tracking_events.kundenportal_product_combo_stockcheck:
            window.gtag('event', 'stockcheck', {
                'dekor': payload.dekor,
                'struktur': payload.struktur,
                'produkt': payload.produkt,
                'rawboard': payload.rawboard,
                'matnr': payload.matnr,
                'query': payload.query,
                'result': payload.result,
            });
            break;
        }
    }
};


export {sal_gtag};
// End Google Anylytics
